import { buttonsStyle } from './styles';
import { Images } from 'utils';


export const EditNewBtn = ({ handleClick }) => {
  const classes = buttonsStyle();

  return(
    <button onClick={handleClick} className={classes.editNewBtn}>
      <img src={Images.edit} alt="Edit" />
    </button>
  )
}